(function () {
  var COUNTS = { single: 1, duo: 2, family: 3 };

  function kr(cents) {
    return Math.round(cents / 100).toLocaleString('sv-SE') + ' kr';
  }

  function initInview() {
    var vids = document.querySelectorAll('video[data-lm-inview]');
    if (!vids.length) return;
    if (!('IntersectionObserver' in window)) { vids.forEach(function (v) { v.preload = 'auto'; v.play().catch(function () {}); }); return; }
    var io = new IntersectionObserver(function (es) {
      es.forEach(function (e) {
        var v = e.target;
        if (e.isIntersecting) { v.preload = 'auto'; v.muted = true; v.play().catch(function () {}); } else { v.pause(); }
      });
    }, { rootMargin: '200px 0px', threshold: 0.15 });
    vids.forEach(function (v) { io.observe(v); });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initInview); else initInview();

  function initGallery(root) {
    var slides = root.querySelectorAll('.lm-gallery__slide');
    var thumbs = root.querySelectorAll('[data-lm-thumb]');
    var track = root.querySelector('[data-lm-track]');
    var i = 0;
    root.querySelectorAll('video[data-lm-rate]').forEach(function (v) {
      var r = parseFloat(v.getAttribute('data-lm-rate')) || 1;
      var set = function () { v.defaultPlaybackRate = r; v.playbackRate = r; };
      set(); v.addEventListener('loadedmetadata', set); v.addEventListener('play', set);
    });
    root.querySelectorAll('[data-lm-sound]').forEach(function (b) {
      var v = b.parentNode.querySelector('video');
      if (!v) return;
      b.addEventListener('click', function (e) {
        e.preventDefault(); e.stopPropagation();
        v.muted = !v.muted;
        if (!v.muted) { v.volume = 1; v.play(); }
        b.setAttribute('aria-pressed', v.muted ? 'false' : 'true');
        b.setAttribute('aria-label', v.muted ? 'Slå på ljud' : 'Stäng av ljud');
      });
    });
    function mark(n) {
      i = n;
      slides.forEach(function (s, k) { s.classList.toggle('is-active', k === i); });
      thumbs.forEach(function (t, k) { t.classList.toggle('is-active', k === i); });
      slides.forEach(function (s, k) {
        if (k === i) return;
        var v = s.querySelector('video'), b = s.querySelector('[data-lm-sound]');
        if (v && !v.muted) { v.muted = true; if (b) { b.setAttribute('aria-pressed', 'false'); b.setAttribute('aria-label', 'Slå på ljud'); } }
      });
    }
    function go(n) {
      n = (n + slides.length) % slides.length;
      mark(n);
      if (track) track.scrollTo({ left: n * track.clientWidth, behavior: 'smooth' });
    }
    if (track) {
      var raf = 0;
      track.addEventListener('scroll', function () {
        cancelAnimationFrame(raf);
        raf = requestAnimationFrame(function () {
          var n = Math.round(track.scrollLeft / Math.max(1, track.clientWidth));
          if (n !== i && n >= 0 && n < slides.length) mark(n);
        });
      }, { passive: true });
      var down = false, sx = 0, sl = 0, si = 0, moved = false;
      track.addEventListener('pointerdown', function (e) {
        if (e.pointerType !== 'mouse') return;
        down = true; moved = false; sx = e.clientX; sl = track.scrollLeft; si = i;
        track.classList.add('is-drag');
      });
      window.addEventListener('pointermove', function (e) {
        if (!down) return;
        if (Math.abs(e.clientX - sx) > 4) moved = true;
        track.scrollLeft = sl - (e.clientX - sx);
      });
      window.addEventListener('pointerup', function (e) {
        if (!down) return;
        down = false;
        track.classList.remove('is-drag');
        var dx = e.clientX - sx, w = track.clientWidth;
        var n = Math.abs(dx) > w * 0.12 ? si + (dx < 0 ? 1 : -1) : si;
        n = Math.max(0, Math.min(slides.length - 1, n));
        mark(n);
        track.scrollTo({ left: n * w, behavior: 'smooth' });
      });
      track.addEventListener('click', function (e) { if (moved) { e.preventDefault(); e.stopPropagation(); moved = false; } }, true);
      track.addEventListener('dragstart', function (e) { e.preventDefault(); });
    }
    var prev = root.querySelector('[data-lm-prev]');
    var next = root.querySelector('[data-lm-next]');
    if (prev) prev.addEventListener('click', function () { go(i - 1); });
    if (next) next.addEventListener('click', function () { go(i + 1); });
    thumbs.forEach(function (t) { t.addEventListener('click', function () { go(+t.dataset.lmThumb); }); });
  }

  function initHero(root) {
    var dataEl = root.querySelector('[data-lm-data]');
    if (!dataEl) return;
    var data = JSON.parse(dataEl.textContent);
    var L = data.i18n || {};
    var tr = function (key, vars) {
      var out = L[key] || '';
      Object.keys(vars || {}).forEach(function (k) { out = out.split('%' + k).join(vars[k]); });
      return out;
    };
    var covers = (data.variants && data.variants.covers) || [];
    var coverOf = function (k) { return covers.filter(function (c) { return c.k === k; })[0] || null; };
    var state = { deal: 'single', covers: [], sizes: [] };
    var COUNT = { single: 1, duo: 2, family: 3 };
    var q = function (s) { return root.querySelector(s); };
    var qa = function (s) { return root.querySelectorAll(s); };

    function dealName(key) {
      var b = q('[data-lm-deal="' + key + '"] .lm-deal__name');
      return b ? b.textContent.trim() : key;
    }

    function render() {
      qa('[data-lm-deal]').forEach(function (b) {
        var on = b.dataset.lmDeal === state.deal;
        b.classList.toggle('is-active', on);
        b.setAttribute('aria-checked', on ? 'true' : 'false');
      });
      var n = COUNT[state.deal] || 1;
      var box = q('[data-lm-sizes]');
      if (box) box.classList.toggle('is-single', n === 1);
      qa('[data-lm-size-row]').forEach(function (row) {
        var i = Number(row.dataset.lmSizeRow) - 1;
        row.hidden = i >= n;
        row.querySelectorAll('[data-lm-size]').forEach(function (b) {
          var on = state.sizes[i] === Number(b.dataset.lmSize);
          b.classList.toggle('is-active', on);
          b.setAttribute('aria-checked', on ? 'true' : 'false');
        });
      });
      var free = (data.free && data.free[state.deal]) || 0;
      qa('[data-lm-cover]').forEach(function (b) {
        var pos = state.covers.indexOf(b.dataset.lmCover);
        var on = pos > -1;
        b.classList.toggle('is-active', on);
        b.setAttribute('aria-pressed', on ? 'true' : 'false');
        var pl = b.querySelector('[data-lm-cover-price]');
        if (pl) {
          if (!pl.dataset.base) pl.dataset.base = pl.textContent;
          var gift = free > 0 && (on ? pos < free : state.covers.length < free);
          pl.textContent = gift ? tr('cover_free') : pl.dataset.base;
          pl.classList.toggle('is-free', gift);
        }
      });
      var sub = q('[data-lm-covers-sub]');
      if (sub) {
        if (!sub.dataset.base) sub.dataset.base = sub.textContent;
        sub.textContent = free > 0 ? (state.deal === 'family' ? sub.dataset.family : sub.dataset.duo) : sub.dataset.base;
      }
      var price = data.prices[state.deal] + Math.max(0, state.covers.length - free) * data.prices.cover;
      q('[data-lm-price]').textContent = kr(data.prices[state.deal]);
      var save = data.compare[state.deal] - data.prices[state.deal];
      var saveEl = q('[data-lm-save]');
      saveEl.style.display = save > 0 ? '' : 'none';
      saveEl.textContent = tr('save', { amount: kr(save) });
      var list = [dealName(state.deal)].concat(state.covers.map(function (k) {
        return tr('summary_cover', { color: coverOf(k) ? coverOf(k).name : k });
      }));
      q('[data-lm-summary]').textContent = tr('summary', { list: list.join(' + ') });
      var atc = q('[data-lm-atc]');
      atc.textContent = tr('add_to_cart', { price: kr(price) });
      atc.disabled = !!data.demo;
    }

    qa('[data-lm-deal]').forEach(function (b) {
      b.addEventListener('click', function () { state.deal = b.dataset.lmDeal; render(); });
    });
    qa('[data-lm-size]').forEach(function (b) {
      b.addEventListener('click', function () {
        var i = Number(b.closest('[data-lm-size-row]').dataset.lmSizeRow) - 1;
        state.sizes[i] = Number(b.dataset.lmSize);
        var box = q('[data-lm-sizes]');
        var n = COUNT[state.deal] || 1;
        var done = true;
        for (var k = 0; k < n; k++) if (!state.sizes[k]) done = false;
        if (box && done) box.classList.remove('is-missing');
        if (done) q('[data-lm-msg]').textContent = '';
        render();
      });
    });
    qa('[data-lm-cover]').forEach(function (b) {
      b.addEventListener('click', function () {
        var k = b.dataset.lmCover;
        var i = state.covers.indexOf(k);
        if (i > -1) state.covers.splice(i, 1); else state.covers.push(k);
        render();
      });
    });

    q('[data-lm-atc]').addEventListener('click', function () {
      var msg = q('[data-lm-msg]');
      var base = (data.variants[state.deal] || [])[0];
      if (!base) { msg.textContent = tr('combo_missing'); return; }
      var n = COUNT[state.deal] || 1;
      var props = {};
      for (var k = 0; k < n; k++) {
        var z = state.sizes[k];
        if (!z) {
          msg.textContent = tr('size_missing');
          var box = q('[data-lm-sizes]');
          if (box) { box.classList.add('is-missing'); box.scrollIntoView({ behavior: 'smooth', block: 'center' }); }
          return;
        }
        var label = n === 1 ? tr('prop_size') : tr('prop_pillow', { n: k + 1 });
        props[label] = data.i18n.sizes[z - 1] + ' · ' + data.i18n.edges[z - 1];
      }
      var items = [{ id: base.id, quantity: 1, properties: props }];
      state.covers.forEach(function (k) {
        var c = coverOf(k);
        if (c && c.id) items.push({ id: c.id, quantity: 1 });
      });
      var btn = this;
      btn.disabled = true;
      var drawer = document.querySelector('cart-drawer');
      var payload = { items: items };
      if (drawer) {
        payload.sections = drawer.getSectionsToRender().map(function (s) { return s.id; });
        payload.sections_url = window.location.pathname;
      }
      fetch(data.cartAddUrl, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify(payload)
      }).then(function (r) {
        if (!r.ok) throw new Error('add');
        return r.json();
      }).then(function (res) {
        btn.disabled = false;
        if (drawer && res.sections) {
          drawer.classList.remove('is-empty');
          drawer.renderContents(res);
        } else {
          window.location.href = data.cartUrl;
        }
      }).catch(function () {
        btn.disabled = false;
        msg.textContent = tr('error');
      });
    });

    render();
  }

  function initScrollers() {
    document.querySelectorAll('[data-lm-scroller]').forEach(function (wrap) {
      var track = wrap.querySelector('[data-lm-track]');
      if (!track) return;
      var step = function () { return track.clientWidth * 0.8; };
      wrap.querySelectorAll('[data-lm-scroll]').forEach(function (b) {
        b.addEventListener('click', function () { track.scrollBy({ left: step() * (+b.dataset.lmScroll), behavior: 'smooth' }); });
      });
      var arrows = wrap.querySelectorAll('[data-lm-scroll]');
      var fit = function () {
        var none = track.scrollWidth <= track.clientWidth + 2;
        arrows.forEach(function (b) { b.style.visibility = none ? 'hidden' : ''; });
      };
      if (arrows.length) { fit(); window.addEventListener('resize', fit); }
      if (track.hasAttribute('data-lm-auto')) autoScroll(track);
    });
  }

  function autoScroll(track) {
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    var cards = Array.prototype.slice.call(track.children);
    if (cards.length < 2) return;
    var first = null;
    cards.forEach(function (c) {
      var k = c.cloneNode(true);
      if (!first) first = k;
      k.setAttribute('aria-hidden', 'true');
      k.removeAttribute('data-shopify-editor-block');
      track.appendChild(k);
    });
    var speed = 38, pos = track.scrollLeft, last = 0, pausedUntil = 0, visible = false;
    var snap = getComputedStyle(track).scrollSnapType;
    var half = function () { return first.offsetLeft - cards[0].offsetLeft; };
    var holding = false;
    var pause = function () { pausedUntil = Date.now() + 3000; track.style.scrollSnapType = snap; };
    ['pointerdown', 'touchstart', 'wheel', 'mouseenter', 'focusin'].forEach(function (e) {
      track.addEventListener(e, function () { holding = e === 'pointerdown' || e === 'touchstart' || e === 'mouseenter'; pause(); }, { passive: true });
    });
    ['pointerup', 'touchend', 'touchcancel', 'pointercancel'].forEach(function (e) {
      track.addEventListener(e, function () { holding = false; pause(); }, { passive: true });
    });
    track.addEventListener('scroll', function () { if (holding || Date.now() < pausedUntil) pausedUntil = Math.max(pausedUntil, Date.now() + 1500); }, { passive: true });
    track.addEventListener('mouseleave', function () { holding = false; pausedUntil = Date.now() + 800; });
    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (es) { visible = es[0].isIntersecting; }).observe(track);
    } else { visible = true; }
    function tick(t) {
      var dt = last ? Math.min(t - last, 100) / 1000 : 0;
      last = t;
      if (visible && !holding && Date.now() > pausedUntil && !document.hidden) {
        if (track.style.scrollSnapType !== 'none') { track.style.scrollSnapType = 'none'; pos = track.scrollLeft; }
        pos += speed * dt;
        if (pos >= half()) pos -= half();
        track.scrollLeft = pos;
      } else {
        pos = track.scrollLeft;
        if (pos >= half()) { pos -= half(); track.scrollLeft = pos; }
      }
      requestAnimationFrame(tick);
    }
    requestAnimationFrame(tick);
  }

  function initVideos() {
    var vids = document.querySelectorAll('.lm-ugc__card video');
    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (es) {
        es.forEach(function (e) {
          var v = e.target;
          if (e.isIntersecting) { var p = v.play(); if (p && p.catch) p.catch(function () {}); }
          else if (!v.paused) v.pause();
        });
      }, { threshold: 0.35 });
      vids.forEach(function (v) { io.observe(v); });
    } else {
      vids.forEach(function (v) { v.autoplay = true; v.preload = 'auto'; v.play(); });
    }
    vids.forEach(function (v) {
      if (v.closest('[data-lm-story]')) return;
      v.addEventListener('click', function () { v.muted = !v.muted; if (v.paused) v.play(); });
    });
  }

  function initStories() {
    document.querySelectorAll('[data-lm-stories]').forEach(function (sec) {
      var view = sec.querySelector('[data-lm-story-view]');
      if (!view) return;
      document.body.appendChild(view);
      var cards = Array.prototype.slice.call(sec.querySelectorAll('[data-lm-story]'));
      var vid = view.querySelector('video');
      var title = view.querySelector('[data-lm-story-title]');
      var sub = view.querySelector('[data-lm-story-sub]');
      var idx = 0, opener = null;
      var srcOf = function (c) {
        var v = c.querySelector('video');
        if (!v) return null;
        var s = v.querySelector('source');
        return { src: v.currentSrc || (s && s.src) || v.src, poster: v.getAttribute('poster') || '' };
      };
      var show = function (i) {
        idx = (i + cards.length) % cards.length;
        var c = cards[idx], m = srcOf(c);
        title.textContent = c.dataset.title || '';
        sub.textContent = c.dataset.sub || '';
        if (m) {
          vid.poster = m.poster;
          vid.src = m.src;
          vid.muted = false;
          var p = vid.play();
          if (p && p.catch) p.catch(function () { vid.muted = true; vid.play().catch(function () {}); });
        }
      };
      var open = function (i) {
        opener = document.activeElement;
        view.hidden = false;
        document.documentElement.style.overflow = 'hidden';
        show(i);
        requestAnimationFrame(function () { view.classList.add('is-open'); });
        view.querySelector('[data-lm-story-close]').focus({ preventScroll: true });
      };
      var close = function () {
        view.classList.remove('is-open');
        vid.pause();
        document.documentElement.style.overflow = '';
        setTimeout(function () { view.hidden = true; vid.removeAttribute('src'); vid.load(); }, 260);
        if (opener && opener.focus) opener.focus({ preventScroll: true });
      };
      cards.forEach(function (c, i) { c.addEventListener('click', function () { open(i); }); });
      view.querySelector('[data-lm-story-close]').addEventListener('click', close);
      view.querySelectorAll('[data-lm-story-step]').forEach(function (b) {
        b.addEventListener('click', function () { show(idx + parseInt(b.dataset.lmStoryStep, 10)); });
      });
      view.querySelector('[data-lm-story-shop]').addEventListener('click', function (e) {
        e.preventDefault();
        close();
        window.scrollTo({ top: 0, behavior: 'smooth' });
      });
      vid.addEventListener('click', function () { vid.muted = !vid.muted; });
      view.addEventListener('click', function (e) { if (e.target === view) close(); });
      document.addEventListener('keydown', function (e) {
        if (view.hidden) return;
        if (e.key === 'Escape') close();
        else if (e.key === 'ArrowRight') show(idx + 1);
        else if (e.key === 'ArrowLeft') show(idx - 1);
      });
    });
  }

  function initAnnouncement() {
    document.querySelectorAll('[data-lm-flag]').forEach(function (f) {
      var iso = (f.dataset.lmFlag || '').toUpperCase();
      if (/^[A-Z]{2}$/.test(iso)) f.textContent = String.fromCodePoint(iso.charCodeAt(0) + 127397, iso.charCodeAt(1) + 127397);
    });
    document.querySelectorAll('[data-lm-ann]').forEach(function (box) {
      var items = box.querySelectorAll('.lm-ann__item');
      if (items.length < 2) return;
      var i = 0;
      setInterval(function () {
        items[i].classList.remove('is-on');
        items[i].setAttribute('aria-hidden', 'true');
        i = (i + 1) % items.length;
        items[i].classList.add('is-on');
        items[i].removeAttribute('aria-hidden');
      }, 2000);
    });
  }

  function initLogoToPacks() {
    var packs = document.getElementById('lm-packs');
    if (!packs) return;
    document.querySelectorAll('.header__heading-link').forEach(function (a) {
      a.addEventListener('click', function (e) {
        e.preventDefault();
        var header = document.querySelector('.section-header');
        var offset = header ? header.getBoundingClientRect().bottom : 0;
        var top = packs.getBoundingClientRect().top + window.pageYOffset - Math.max(offset, 0) - 12;
        window.scrollTo({ top: top, behavior: 'smooth' });
      });
    });
  }

  function openFaq(id) {
    var d = id && document.getElementById(id);
    if (!d || d.tagName !== 'DETAILS') return false;
    d.open = true;
    var header = document.querySelector('.section-header');
    var offset = header ? Math.max(header.getBoundingClientRect().bottom, 0) : 0;
    window.scrollTo({ top: d.getBoundingClientRect().top + window.pageYOffset - offset - 16, behavior: 'smooth' });
    return true;
  }

  document.addEventListener('click', function (e) {
    var a = e.target.closest('a[href^="#lm-faq-"]');
    if (a && openFaq(a.getAttribute('href').slice(1))) e.preventDefault();
  });

  function initTickers() {
    document.querySelectorAll('[data-lm-ticker]').forEach(function (box) {
      var items = box.querySelectorAll('.lm-ticker__item');
      if (items.length < 2) return;
      var i = 0;
      var show = function (n) {
        items[i].classList.remove('is-on');
        items[i].setAttribute('aria-hidden', 'true');
        i = (n + items.length) % items.length;
        items[i].classList.add('is-on');
        items[i].removeAttribute('aria-hidden');
      };
      var timer = setInterval(function () { show(i + 1); }, 3000);
      box.addEventListener('click', function (e) {
        if (e.target.closest('[data-lm-ticker-next]')) return;
        var track = document.querySelector('.lm-reviews__track');
        var target = track ? track.closest('section') : null;
        if (!target) return;
        var header = document.querySelector('.section-header');
        var off = header ? Math.max(header.getBoundingClientRect().bottom, 0) : 0;
        window.scrollTo({ top: target.getBoundingClientRect().top + window.pageYOffset - off, behavior: 'smooth' });
      });
      var next = box.querySelector('[data-lm-ticker-next]');
      if (next) next.addEventListener('click', function () {
        clearInterval(timer);
        show(i + 1);
        timer = setInterval(function () { show(i + 1); }, 3000);
      });
    });
  }

  function initSticky() {
    var bar = document.querySelector('[data-lm-sticky]');
    var atc = document.querySelector('[data-lm-atc]');
    if (!bar || !atc) return;
    document.body.appendChild(bar);
    document.body.classList.add('lm-has-sticky');
    var setH = function () { document.documentElement.style.setProperty('--lm-sticky-h', bar.offsetHeight + 'px'); };
    setH();
    window.addEventListener('resize', setH);
    var sel = bar.querySelector('[data-lm-sticky-size]');
    var btn = bar.querySelector('[data-lm-sticky-btn]');
    var sync = function () {
      btn.textContent = atc.textContent;
      var single = document.querySelector('[data-lm-deal="single"]');
      var isSingle = single && single.classList.contains('is-active');
      sel.parentNode.style.display = isSingle ? '' : 'none';
      var on = document.querySelector('[data-lm-size-row="1"] .lm-size.is-active');
      sel.value = on ? on.dataset.lmSize : '';
    };
    new IntersectionObserver(function (es) {
      var visible = es[0].isIntersecting || es[0].boundingClientRect.top > window.innerHeight;
      bar.classList.toggle('is-on', !visible);
      bar.setAttribute('aria-hidden', visible ? 'true' : 'false');
      if (!visible) sync();
    }).observe(atc);
    new MutationObserver(sync).observe(atc, { childList: true, characterData: true, subtree: true });
    sel.addEventListener('change', function () {
      var b = document.querySelector('[data-lm-size-row="1"] [data-lm-size="' + sel.value + '"]');
      if (b) b.click();
    });
    btn.addEventListener('click', function () {
      var single = document.querySelector('[data-lm-deal="single"]');
      var isSingle = single && single.classList.contains('is-active');
      if (isSingle && sel.value) { atc.click(); return; }
      var packs = document.getElementById('lm-packs');
      if (packs) {
        var header = document.querySelector('.section-header');
        var off = header ? Math.max(header.getBoundingClientRect().bottom, 0) : 0;
        window.scrollTo({ top: packs.getBoundingClientRect().top + window.pageYOffset - off - 12, behavior: 'smooth' });
      }
    });
  }

  function init() {
    if (location.hash.indexOf('#lm-faq-') === 0) setTimeout(function () { openFaq(location.hash.slice(1)); }, 300);
    initAnnouncement();
    initTickers();
    initSticky();
    initLogoToPacks();
    document.querySelectorAll('[data-lm-gallery]').forEach(function (g) { initGallery(g.closest('.lm-hero__media')); });
    document.querySelectorAll('.lm-hero').forEach(initHero);
    initScrollers();
    initVideos();
    initStories();
    preloadGallery();
    initProtect();
  }

  function initProtect() {
    if (window.Shopify && window.Shopify.designMode) return;
    document.documentElement.classList.add('lm-protect');
    var editable = function (el) { return el && el.closest && el.closest('input, textarea, select, [contenteditable="true"]'); };
    document.addEventListener('contextmenu', function (e) { if (!editable(e.target)) e.preventDefault(); });
    document.addEventListener('dragstart', function (e) { if (e.target.closest && e.target.closest('img, video, picture, a')) e.preventDefault(); });
    document.addEventListener('copy', function (e) { if (!editable(document.activeElement)) e.preventDefault(); });
    document.addEventListener('keydown', function (e) {
      var k = (e.key || '').toLowerCase();
      var mod = e.ctrlKey || e.metaKey;
      if (k === 'f12' || (mod && (k === 's' || k === 'u' || k === 'p')) || (mod && e.shiftKey && (k === 'i' || k === 'j' || k === 'c'))) { e.preventDefault(); return; }
      if (mod && (k === 'c' || k === 'a') && !editable(e.target)) e.preventDefault();
    });
    document.querySelectorAll('img, video').forEach(function (m) { m.setAttribute('draggable', 'false'); });
  }

  function preloadGallery() {
    var go = function () {
      document.querySelectorAll('.lm-gallery__slide img[loading="lazy"]').forEach(function (i) { i.loading = 'eager'; });
    };
    if (document.readyState === 'complete') setTimeout(go, 300);
    else window.addEventListener('load', function () { setTimeout(go, 300); });
  }

  document.addEventListener('click', function (e) {
    var pick = e.target.closest('[data-lm-cup-pick]');
    if (pick) {
      var box = pick.closest('[data-lm-cup]');
      box.querySelectorAll('[data-lm-cup-pick]').forEach(function (b) {
        var on = b === pick;
        b.classList.toggle('is-active', on);
        b.setAttribute('aria-checked', on ? 'true' : 'false');
      });
      box.querySelector('[data-lm-cup-add]').dataset.lmCupAdd = pick.dataset.lmCupPick;
      var thumb = box.querySelector('[data-lm-cup-thumb]');
      if (thumb) thumb.src = pick.dataset.img;
      return;
    }
    var add = e.target.closest('[data-lm-cup-add]');
    if (!add) return;
    add.disabled = true;
    var drawer = document.querySelector('cart-drawer');
    var payload = { items: [{ id: Number(add.dataset.lmCupAdd), quantity: 1 }] };
    if (drawer) {
      payload.sections = drawer.getSectionsToRender().map(function (s) { return s.id; });
      payload.sections_url = window.location.pathname;
    }
    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    fetch(root + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(payload)
    }).then(function (r) {
      if (!r.ok) throw new Error('add');
      return r.json();
    }).then(function (res) {
      if (drawer && res.sections) drawer.renderContents(res);
      else window.location.reload();
    }).catch(function () { add.disabled = false; });
  });

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();

(function () {
  var pop, timer, current;
  function ensure() {
    if (pop) return pop;
    pop = document.createElement('div');
    pop.className = 'lm-zoom';
    pop.setAttribute('aria-hidden', 'true');
    pop.innerHTML = '<img alt=""><span class="lm-zoom__name"></span>';
    document.body.appendChild(pop);
    return pop;
  }
  function open(sw) {
    clearTimeout(timer);
    var p = ensure();
    current = sw;
    p.querySelector('img').src = sw.getAttribute('data-lm-zoom');
    var card = sw.closest('.lm-color');
    var name = card && card.querySelector('.lm-color__name');
    p.querySelector('.lm-zoom__name').textContent = name ? name.textContent : '';
    var r = sw.getBoundingClientRect();
    var size = Math.min(240, window.innerWidth - 24);
    var left = Math.max(12, Math.min(window.innerWidth - size - 12, r.left + r.width / 2 - size / 2));
    var top = r.top - size - 12;
    var below = top < 12;
    if (below) top = r.bottom + 12;
    p.style.left = left + 'px';
    p.style.top = top + 'px';
    var ox = Math.max(0, Math.min(100, ((r.left + r.width / 2 - left) / size) * 100));
    p.style.setProperty('--lm-zoom-origin', ox + '% ' + (below ? '0%' : '100%'));
    requestAnimationFrame(function () { p.classList.add('is-open'); });
  }
  function close() {
    if (!pop) return;
    current = null;
    pop.classList.remove('is-open');
  }
  function swatchFrom(e) { return e.target.closest && e.target.closest('[data-lm-zoom]'); }
  document.addEventListener('pointerover', function (e) {
    if (e.pointerType !== 'mouse') return;
    var sw = swatchFrom(e);
    if (sw && sw !== current) open(sw);
  });
  document.addEventListener('pointerout', function (e) {
    if (e.pointerType !== 'mouse' || !current) return;
    if (!current.contains(e.relatedTarget)) close();
  });
  document.addEventListener('touchstart', function (e) {
    var sw = swatchFrom(e);
    if (sw) open(sw);
  }, { passive: true });
  ['touchend', 'touchcancel'].forEach(function (t) {
    document.addEventListener(t, function () { if (current) timer = setTimeout(close, 120); }, { passive: true });
  });
  window.addEventListener('scroll', close, { passive: true });
})();
